import AppHeader from '@hellodarwin/app-core/lib/layouts/app-layout/components/AppHeader';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import { useMemo } from 'react';
import { useAppSelector } from '../app/app-hooks';
import { selectProfile } from '../features/api/slices/profile-slice';
import { resolveHeaderUserMenuLinks } from './header-user-menu-links';

const ExpertAppHeader = () => {
  const profile = useAppSelector(selectProfile);
  const { t } = useTranslations();

  const userMenuLinks = useMemo(
    () => resolveHeaderUserMenuLinks('expert', t),
    [t],
  );

  return (
    <AppHeader
      profile={profile}
      userMenuLinks={userMenuLinks}
      hideDesktopLogo
    />
  );
};

export default ExpertAppHeader;
